import { useQuery } from "@tanstack/react-query";
import { api } from "@/api";

export const platformRoleKeys = {
	all: ["platformRoles"] as const,
	catalog: ["platformRoles", "catalog"] as const,
};

export function usePlatformRoles() {
	return useQuery({
		queryKey: platformRoleKeys.all,
		queryFn: () => api.platformRoles.list(),
	});
}

export function usePlatformRoleCatalog() {
	return useQuery({
		queryKey: platformRoleKeys.catalog,
		queryFn: () => api.platformRoles.catalog(),
	});
}
